import React, { useState } from "react";
import "./Contact.css";

const CONTACT_ITEMS = [
  {
    icon: "pi pi-whatsapp",
    label: "WhatsApp",
    value: "Escríbenos directo",
    note: "Respuesta rápida en horario de atención.",
    href: "https://wa.me/message/CJH5F4NQS6PNN1",
  },
  {
    icon: "pi pi-instagram",
    label: "Instagram",
    value: "@angelvarius.shop",
    note: "Síguenos para ver novedades y lanzamientos.",
    href: "https://www.instagram.com/angelvarius.shop/",
  },
  {
    icon: "pi pi-facebook",
    label: "Facebook",
    value: "angelvarius.shop.fb",
    note: "Síguenos para ver novedades y lanzamientos.",
    href: "https://www.facebook.com/angelvarius.shop.fb/",
  },
  {
    icon: "pi pi-envelope",
    label: "Correo",
    value: "angelvarius.shop@gmail.com",
    note: "Para pedidos especiales o cotizaciones.",
    href: null /*"mailto:angelvarius.shop@gmail.com"*/,
  },
  {
    icon: "pi pi-map-marker",
    label: "Entregas en GDL",
    value: "Guadalajara, Jalisco",
    note: "Punto de encuentro en Plaza del Sol o punto acordado.",
    href: null,
  },
];

const FAQ = [
  {
    q: "¿Cuánto tarda en llegar mi pedido?",
    a: "Los envíos por Correos de México suelen tomar entre 3 y 7 días hábiles. Otras paqueterías pueden ser más rápidas según la cobertura.",
  },
  {
    q: "¿Cómo funciona el sistema de apartados?",
    a: "Puedes apartar cualquier figura con el 20% de su valor. El restante lo pagas cuando gustes y el envío/entrega se realiza al completar el pago.",
  },
  {
    q: "¿Las figuras son originales?",
    a: "Sí, todas nuestras figuras son 100% originales importadas de Japón. Trabajamos con marcas como Bandai, Good Smile Company, Kaiyodo, Sega y Bandai Hobby.",
  },
  {
    q: "¿Aceptan pedidos especiales o encargos?",
    a: "¡Claro! Si buscas una figura específica que no está en el catálogo, escríbenos y lo cotizamos.",
  },
];

export default function Contacto() {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (i) => setOpenFaq(openFaq === i ? null : i);

  return (
    <div className="contacto-page">

      {/* ── Hero ── */}
      <header className="contacto-hero">
        <div className="contacto-hero__inner">
          <span className="contacto-hero__eyebrow">Angelvarius Shop</span>
          <h1 className="contacto-hero__title">Contáctanos</h1>
          <p className="contacto-hero__sub">
            Estamos para ayudarte con tu pedido, cotización o cualquier duda sobre
            nuestras figuras.
          </p>
        </div>
        <div className="contacto-hero__deco" aria-hidden="true">
          <span className="contacto-hero__deco-ring contacto-hero__deco-ring--1" />
          <span className="contacto-hero__deco-ring contacto-hero__deco-ring--2" />
        </div>
      </header>

      <main className="contacto-content">

        {/* ── Canales ── */}
        <section className="contacto-section">
          <div className="contacto-section__head">
            <span className="contacto-label">Dónde encontrarnos</span>
            <h2 className="contacto-heading">Canales de contacto</h2>
          </div>
          <div className="contacto-channels">
            {CONTACT_ITEMS.map((item) => (
              item.href ? (
                <a
                  key={item.label}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contacto-channel contacto-channel--link"
                >
                  <ChannelContent item={item} />
                </a>
              ) : (
                <div key={item.label} className="contacto-channel">
                  <ChannelContent item={item} />
                </div>
              )
            ))}
          </div>
        </section>

        {/* ── Divider ── */}
        <div className="contacto-divider" aria-hidden="true" />

        {/* ── FAQ ── */}
        <section className="contacto-section">
          <div className="contacto-section__head">
            <span className="contacto-label">Preguntas frecuentes</span>
            <h2 className="contacto-heading">Respuestas rápidas</h2>
          </div>
          <div className="contacto-faq">
            {FAQ.map((item, i) => (
              <div
                key={i}
                className={`contacto-faq__item${openFaq === i ? " contacto-faq__item--open" : ""}`}
              >
                <button
                  className="contacto-faq__question"
                  onClick={() => toggleFaq(i)}
                  aria-expanded={openFaq === i}
                >
                  <span>{item.q}</span>
                  <i className={`pi ${openFaq === i ? "pi-minus" : "pi-plus"} contacto-faq__caret`} />
                </button>
                <div className="contacto-faq__answer">
                  <p>{item.a}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ── Notice ── */}
        <div className="contacto-notice">
          <i className="pi pi-clock contacto-notice__icon" />
          <p className="contacto-notice__text">
            Nuestro horario de atención es de lunes a sábado. Respondemos lo antes
            posible, generalmente en el mismo día.
          </p>
        </div>

      </main>
    </div>
  );
}

function ChannelContent({ item }) {
  return (
    <>
      <div className="contacto-channel__icon">
        <i className={item.icon} />
      </div>
      <div className="contacto-channel__body">
        <span className="contacto-channel__label">{item.label}</span>
        <span className="contacto-channel__value">{item.value}</span>
        <span className="contacto-channel__note">{item.note}</span>
      </div>
      {item.href && (
        <i className="pi pi-arrow-up-right contacto-channel__arrow" />
      )}
    </>
  );
}
